<div class="container-fluid py-3 py-md-4 timesheet-page">
  <div class="card shadow-sm border-0 mb-3">
    <div class="card-body">
      <div
        class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3"
      >
        <div>
          <h4 class="mb-1">Timesheet</h4>
          <p class="text-muted mb-0">{{ employeeName }}</p>
        </div>

        <div class="d-flex align-items-center gap-2 week-nav">
          <button
            class="btn btn-outline-secondary btn-sm"
            type="button"
            (click)="goToPreviousWeek()"
            [disabled]="isLoading"
            aria-label="Previous week"
          >
            <i class="bi bi-chevron-left"></i>
          </button>
          <div class="week-label fw-semibold text-center">{{ weekLabel }}</div>
          <button
            class="btn btn-outline-secondary btn-sm"
            type="button"
            (click)="goToNextWeek()"
            [disabled]="isLoading"
            aria-label="Next week"
          >
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>
      </div>

      <div class="mt-3 d-flex flex-column align-items-start">
        <button
          class="btn"
          [ngClass]="isClockedIn ? 'btn-danger' : 'btn-primary'"
          type="button"
          [disabled]="isClockActionLoading || isLoading || !employeeId"
          (click)="onClockAction()"
        >
          <span
            *ngIf="isClockActionLoading"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          {{ isClockedIn ? "Clock Out" : "Clock In" }}
        </button>

        <small *ngIf="activeEntry" class="text-muted mt-2">
          Clocked in at {{ formatTime(activeEntry.clockIn) }}
        </small>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger mt-3 mb-0 py-2">
        {{ errorMessage }}
      </div>
    </div>
  </div>

  <div class="card shadow-sm border-0">
    <div class="card-body p-0 p-md-3">
      <div class="table-responsive">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-light">
            <tr>
              <th>Day</th>
              <th>Date</th>
              <th>Time In</th>
              <th>Time Out</th>
              <th>Hours</th>
              <th>Note</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let group of groups; trackBy: trackByDate">
              <ng-container
                *ngIf="group.entries.length === 0; else dayWithEntries"
              >
                <tr [class.today-group]="group.isToday">
                  <td class="fw-semibold">{{ group.dayLabel }}</td>
                  <td>{{ group.dateLabel }}</td>
                  <td>—</td>
                  <td>—</td>
                  <td>—</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0"
                      (click)="openManualEntryModal(group)"
                    >
                      + Add
                    </button>
                  </td>
                </tr>
                <tr class="day-total-row" [class.today-group]="group.isToday">
                  <td colspan="6" class="text-end small fw-semibold">
                    Total: {{ group.dayTotal.toFixed(2) }} hrs
                  </td>
                </tr>
              </ng-container>

              <ng-template #dayWithEntries>
                <ng-container
                  *ngFor="
                    let entry of group.entries;
                    let first = first;
                    let idx = index
                  "
                >
                  <tr [class.today-group]="group.isToday">
                    <td
                      *ngIf="first"
                      [attr.rowspan]="group.rowSpan"
                      class="fw-semibold"
                    >
                      {{ group.dayLabel }}
                    </td>
                    <td *ngIf="first" [attr.rowspan]="group.rowSpan">
                      {{ group.dateLabel }}
                    </td>
                    <td>{{ formatTime(entry.clockIn) }}</td>
                    <td>
                      {{ entry.clockOut ? formatTime(entry.clockOut) : "—" }}
                    </td>
                    <td>
                      {{
                        entry.hoursWorked !== null
                          ? (entry.hoursWorked | number: "1.2-2")
                          : "—"
                      }}
                    </td>
                    <td>{{ entry.note || "—" }}</td>
                  </tr>

                  <tr
                    *ngIf="getGapNote(group, idx) as gap"
                    class="gap-note-row"
                    [class.today-group]="group.isToday"
                  >
                    <td colspan="4" class="text-muted small fst-italic ps-3">
                      {{ gap.label }}
                    </td>
                  </tr>
                </ng-container>

                <tr class="day-total-row" [class.today-group]="group.isToday">
                  <td colspan="6" class="text-end small fw-semibold">
                    Total: {{ group.dayTotal.toFixed(2) }} hrs
                  </td>
                </tr>
              </ng-template>
            </ng-container>
          </tbody>
          <tfoot>
            <tr class="table-secondary">
              <td colspan="4" class="text-end fw-bold">Week Total</td>
              <td class="fw-bold">{{ weekTotal.toFixed(2) }}</td>
              <td class="fw-bold">hrs</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>

<div
  #manualEntryModal
  class="modal fade"
  id="manualEntryModal"
  tabindex="-1"
  aria-labelledby="manualEntryModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="manualEntryModalLabel">
          Manual Time Entry
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <form [formGroup]="manualEntryForm" (ngSubmit)="submitManualEntry()">
        <div class="modal-body">
          <p class="mb-3 text-muted">{{ selectedManualDateLabel }}</p>

          <div class="row g-3">
            <div class="col-6">
              <label class="form-label" for="timeIn">Time In</label>
              <input
                id="timeIn"
                type="time"
                class="form-control"
                formControlName="timeIn"
              />
            </div>

            <div class="col-6">
              <label class="form-label" for="timeOut">Time Out</label>
              <input
                id="timeOut"
                type="time"
                class="form-control"
                formControlName="timeOut"
              />
            </div>

            <div class="col-12">
              <label class="form-label" for="note">Note (optional)</label>
              <textarea
                id="note"
                rows="3"
                class="form-control"
                formControlName="note"
                placeholder="Optional note"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-bs-dismiss="modal"
            [disabled]="manualSaving"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="manualSaving"
          >
            <span
              *ngIf="manualSaving"
              class="spinner-border spinner-border-sm me-2"
              aria-hidden="true"
            ></span>
            Save Entry
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
